export default __webpack_public_path__ + "static/media/BUE.eef2ab51.png";